{
  "page": {
    "title": "Members",
    "subtitle": "Manage your organization members"
  },
  "table": {
    "member": "Member",
    "role": "Role",
    "area": "Area",
    "expiration": "Expiration",
    "status": "Status",
    "joinedAt": "Join date"
  },
  "toolbar": {
    "search": "Search members...",
    "invite": "Invite member"
  },
  "filters": {
    "trigger": "Filters",
    "search": "Search members",
    "reset": "Clear filters"
  },
  "invite": {
    "title": "Invite new member",
    "description": "Enter the email address of the person you want to invite to the organization.",
    "email": "Email",
    "emailPlaceholder": "email@example.com",
    "role": "Role",
    "expiration": "Expiration date (optional)",
    "placeholder": "No expiration date",
    "submit": "Send invitation",
    "submitting": "Sending...",
    "cancel": "Cancel"
  },
  "actions": {
    "openMenu": "More options",
    "viewProfile": "View profile",
    "copyEmail": "Copy email",
    "workSchedule": "Work schedule",
    "setHireDate": "Set hire date",
    "delete": "Delete"
  },
  "setHireDate": {
    "description": "Required before a Time Off entitlement cycle can be opened for {{name}}.",
    "label": "Hire date",
    "cancel": "Cancel",
    "save": "Save date"
  },
  "confirm": {
    "changeStatus": "Change status",
    "changeStatusDesc": "Are you sure you want to {{action}} \"{{name}}\"?",
    "delete": "Delete member",
    "deleteDesc": "Are you sure you want to remove \"{{name}}\" from the organization? This action cannot be undone.",
    "confirm": "Confirm",
    "cancel": "Cancel"
  },
  "toast": {
    "statusUpdatedActive": "Member activated",
    "statusUpdatedActiveDesc": "The status of \"{{name}}\" has been updated",
    "statusUpdatedPending": "Member deactivated",
    "statusUpdatedPendingDesc": "The status of \"{{name}}\" has been updated",
    "inviteSent": "Invitation sent",
    "inviteSentDesc": "An invitation has been sent to {{email}}",
    "deleted": "Member deleted",
    "deletedDesc": "{{name}} has been removed from the organization.",
    "emailCopied": "Email copied",
    "emailCopiedDesc": "The email {{email}} has been copied to clipboard.",
    "roleUpdated": "Role updated",
    "roleUpdatedDesc": "The role of \"{{name}}\" has been updated",
    "expirationUpdated": "Expiration updated",
    "expirationUpdatedDesc": "The expiration of \"{{name}}\" has been updated",
    "hireDateSet": "Hire date set",
    "hireDateSetDesc": "{{name}}'s hire date has been set.",
    "error": "Error",
    "errorDesc": "Please try again later."
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive"
  },
  "area": {
    "none": "No area",
    "noneDescription": "No area assigned",
    "assign": "Assign area",
    "assignSuccess": "Area assigned successfully",
    "assignError": "Failed to assign area",
    "search": "Search area...",
    "clear": "No area"
  },
  "role": {
    "owner": "Owner",
    "admin": "Administrator",
    "collaborator": "Collaborator",
    "client": "Client",
    "viewer": "Viewer"
  },
  "expiration": {
    "none": "No expiration",
    "select": "Select date"
  },
  "tabs": {
    "members": "Members",
    "invitations": "Pending Invitations"
  },
  "loading": "Loading...",
  "empty": "No members in this organization",
  "you": "(You)",
  "errors": {
    "emailRequired": "Email is required",
    "emailInvalid": "Enter a valid email address",
    "roleRequired": "Select a role"
  },
  "invitations": {
    "title": "Pending invitations",
    "empty": "No pending invitations",
    "columns": {
      "email": "Email",
      "role": "Role",
      "expires": "Expiration",
      "sentAt": "Sent"
    },
    "cancel": "Cancel",
    "cancelConfirm": "Cancel invitation?",
    "cancelConfirmDesc": "The invitation sent to {{email}} will be revoked.",
    "cancelledToast": "Invitation cancelled"
  },
  "apiErrors": {
    "notFound": "Member not found",
    "alreadyExists": "A member with this email is already registered",
    "cannotChangeOwnerRole": "Cannot change the owner's role",
    "cannotDeactivateOwner": "Cannot deactivate the owner",
    "cannotRemoveOwner": "Cannot remove the owner",
    "clientIdRequired": "A client is required for the client role",
    "clientIdNotAllowed": "Client ID is only allowed for the client role",
    "clientNotInTenant": "The selected client does not belong to this organization",
    "invitationAlreadyExists": "A pending invitation already exists for this email",
    "memberLimitExceeded": "Cannot invite: member limit for the current plan would be exceeded",
    "inviteDefault": "Could not send the invitation",
    "toggleDefault": "Could not update the member's status",
    "updateDefault": "Could not update the member",
    "deleteDefault": "Could not remove the member",
    "hireDateDefault": "Could not set the hire date",
    "invitationNotFound": "Invitation not found",
    "cancelInviteDefault": "Could not cancel the invitation"
  }
}
